import DOMPurify from 'dompurify';

export const sanitizeInput = (element) => {
  const inputValue = element.value;

  const originalValue = inputValue;

  // Allow only <p> tags and their attributes, while removing all other tags
  const config = {
    ALLOWED_TAGS: ['p', 'b'],
    ADD_ATTR: ['style']
  };
  const sanitizedInput = DOMPurify.sanitize(inputValue, config);
  if (originalValue !== sanitizedInput) {
    alert("Oops! It seems there's an issue with the information you provided. Please double-check your input and ensure it meets the required format.");
   // Clear the input field
   element.value = '';
  }
  element.value = sanitizedInput;
};
